import DrugsContainer from './drugs-container';

export default DrugsContainer;